<template>
  <Modal
    v-model="_value"
    width="400"
    title="ZT测试模式"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="110">
      <FormItem prop="enabled" label="测试模式开启" show-message>
        <Select v-model="setDriverCardParams.enabled" style="width: 220px;">
          <Option v-for="item in enabledOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

  import Vue from 'vue'
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'

  import MaintainOrderAddMaintainDeviceRecordModal
    from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

  export default {
    name: 'ztsettestpatternmodal',
    components: {},
    props: {
      initValue: null,
      terminalNumValue: null,
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        setDriverCardParams: {
          id: null,
          enabled: 0,
        },
        //协议通道
        enabledOptions: [
          {name: '开启测试模式', value: 0},
          {name: '关闭测试模式', value: 1},
        ],

      }
    },
    methods: {
      ...mapActions([
        'VehicleInfoServ_SearchByName'
      ]),
      visibleChange(val) {
        if (val) {
          this.setDriverCardParams.id = this._initValue
          this.setDriverCardParams.enabled = 0
        }
      },
      onCleanDriverCardParams() {
        this.setDriverCardParams.enabled = 0
      },
      onSendDriverCardParams() {

        let content = null

        if (this.setDriverCardParams.enabled == 0){
          content = '_CoMmAnD@XmL:<Param_DsmAlarmSet><MESSAGE_ID>1</MESSAGE_ID><MESSAGE_TYPE>2</MESSAGE_TYPE><StartSpd>0</StartSpd><VideoResolution>1</VideoResolution><PicResolution>1</PicResolution></Param_DsmAlarmSet>'
        }else {
          content = '_CoMmAnD@XmL:<Param_DsmAlarmSet><MESSAGE_ID>1</MESSAGE_ID><MESSAGE_TYPE>2</MESSAGE_TYPE><StartSpd>30</StartSpd><VideoResolution>1</VideoResolution><PicResolution>1</PicResolution></Param_DsmAlarmSet>'
        }

        console.log(content)


        store.dispatch('NetCommandServ_SendCommand', {
          params: {
            id: this._initValue,
            content: content,
            urgent: true
          }
        }).then(() => {
          this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    },
    computed: {
      _value: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _terminalNumValue: {
        get() {
          return this.terminalNumValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
